import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import WallPlaceholder from '@root/__wall/WallPlaceholder';
import AppModal from './AppModal';

const Appwalls = (props) => {
    const [appDetails, setAppDetails] = useState({ appDetailsArray: [], message: {} });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedApp, setSelectedApp] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const url = `/ajax/api.php?action=get.taskwall`;
            
            try {
                const response = await axios({
                    url: url,
                    method: "POST",
                    data: {
                        placement_identifier: props.placement_identifier,
                        uid: props.uid,
                        gaid: props.gaid,
                        idfa: props.idfa
                    },
                    withCredentials: false,
                    headers: { 
                        "Content-Type": "multipart/form-data" 
                    },
                });
                if(response.data.status === 'success' && response.data.count > 0){
                    const appDetailsArray = Object.values(response.data.data);
                    const message = response.data.message;
                    setAppDetails({appDetailsArray, message});
                }else{
                    setAppDetails({ appDetailsArray: [], message: response.data.message });
                }
            } catch (error) {
                setError('Failed to load data. Please try again later.');
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [props]);

    useEffect(() => {
        if (!loading && appDetails.appDetailsArray.length > 0) {
            coreTPWall.filterByOS(os); 
        }
    }, [loading, appDetails, os]);
    
    const handleItemClick = (app) => {
        setSelectedApp(app);
        const modal = new bootstrap.Modal(document.getElementById("appModal"));
        modal.show();
    }

    const generateListItem = (val, message) => {
        const conversionsText = val.conversions === 0 ? '' : (<span>{val.conversions} <i className="bi bi-people" title="Users"></i> earned {val.conversions * val.payout_vc} coins.</span>);
        const filter = (val.os[0].length !== 0) ? `${val.platform} ${val.os.join(" ")}` : `${val.platform} unspecified`;
 		const redirect_url = val.redirect_url;
		const click_url = `${redirect_url}&t=${Date.now()}`;
        const payout_vc = val.payout_vc.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

        return (
            <li className={`filter ${filter}`} key={val.id} onClick={() => handleItemClick(val)}>
                <div className="item">
                    <div className="imageWrapper">
						<img src={val.app_icon} alt={val.app_name} className="imaged w64 img-fluid border rounded-md shadow"/>
                    </div>
                    <div className="in">
                        <div>
                            <span className="Xtext-truncateX">
                                {val.app_name} 
                                <span dangerouslySetInnerHTML={{ __html: coreTPWall.formatDateTime('isNew', moment(val.created, 'YYYY-MM-DD HH:mm:ss').valueOf()) }}></span>
                            </span>
                            <div className="text-muted" dangerouslySetInnerHTML={{ __html: coreTPWall.payoutTypeToAction(val.payout_type, val) }}></div>
                            <p className="card-text mb-1">
                                <small className="text-muted">{conversionsText}</small>
                            </p>
                            <small className="text-muted" dangerouslySetInnerHTML={{ __html: coreTPWall.platformToLabel(val.platform, val) }}></small>
                        </div>
                        <div className="btn-group" role="group">
							<a className="btn btn-warning btn-sm btn-block" href={click_url} target="_blank" style={{width: "100%"}}>
								<i className="fa fa-coins fa-fw"></i> <i className="bi bi-plus m-0"></i>{payout_vc} 
								<span className="d-none d-sm-block">&nbsp;{message.currency_name}</span>
							</a>                            
                        </div>
                    </div>
                </div>
            </li>
        );
    };

    const renderFallback = (message) => {
        return (
            <li className="filter unspecified" key="fallback">
                <div className="item">
                    <div className="imageWrapper">
                        <img src={`https://i3.wp.com/${site['domain']}/static/image/logo_512x512.png?resize=200,200&filter=grayscale`} alt="App Name" className="imaged w64 img-fluid border rounded-lg shadow" />
                    </div>
                    <div className="in">
                        <div>
                            New offers coming soon
                            <div className="text-muted d-none">Check back later</div>
                            <p className="card-text text-muted small mb-1">
                                Oops! Someone ate all the offers. Try <a href="#" onClick={() => window.location.reload()}><u>refreshing</u></a> for more offers.
                            </p>
                            <small className="text-muted">
                                <span className="badge rounded-pill bg-secondary">Android</span>
                                <span className="badge rounded-pill bg-secondary mx-1">iOS</span>
                                <span className="badge rounded-pill bg-secondary">Web</span>
                            </small>
                        </div>
                        <span className="text-muted">
                            <a className="btn btn-secondary btn-sm btn-block disabled" href="#" target="_blank">
                                <i className="fas fa-coins fa-fw"></i> <i className="bi bi-plus m-0"></i>11,000.00 {message.currency_name}
                            </a>
                        </span>
                    </div>
                </div>
            </li>
        );
    };

    if (loading) {
        // return <div>Loading...</div>;
        return <WallPlaceholder />;
    }
    if (error) {
        return <div>{error}</div>;
    }
    return (
        <>
            <ul id="appDetails" className="listview image-listview media mb-2">
                {appDetails.appDetailsArray.length > 0 ? appDetails.appDetailsArray.map(val => generateListItem(val, appDetails.message)) : renderFallback(appDetails.message)}
            </ul>
            <AppModal selectedApp={selectedApp} />
        </>
    );
};

export default Appwalls;
